import { render, staticRenderFns } from "./OpenSourceLicense.vue?vue&type=template&id=addad9f6&scoped=true&"
import script from "./OpenSourceLicense.vue?vue&type=script&lang=ts&"
export * from "./OpenSourceLicense.vue?vue&type=script&lang=ts&"
import style0 from "./OpenSourceLicense.vue?vue&type=style&index=0&id=addad9f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addad9f6",
  null
  
)

export default component.exports